import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from '@/shared/hooks/useAuth'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* La sesión vive aquí, encima de App: una sola instancia para todos. */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
